import React, { useEffect, useState } from "react";
import axios from "axios";
import "./VisionIgniteWebinar.css";
import { FaUser, FaEnvelope, FaPhoneAlt } from "react-icons/fa";

const getNextSaturday = () => {

  const now = new Date();

  const next = new Date(now);

  const daysUntilSaturday =
    (6 - next.getDay() + 7) % 7;

  next.setDate(
    next.getDate() + daysUntilSaturday
  );

  next.setHours(17, 0, 0, 0);
  

  if (next <= now) {
    next.setDate(next.getDate() + 7);
  }

  return next;

};

const VisionIgniteWebinar = () => {

  // Hide website footer
  useEffect(() => {
    const navbar = document.querySelector("header, .navbar");
    const footer = document.querySelector("footer");
  
   
    if (navbar) navbar.style.display = "none";
    if (footer) footer.style.display = "none";
  
    return () => {
      // 🔥 மீண்டும் restore
      if (navbar) navbar.style.display = "";
      if (footer) footer.style.display = "";
    };
  }, []);
  

  // Remove ElevenLabs widget
  useEffect(() => {

    const hideWidget = () => {

      document
        .querySelectorAll("elevenlabs-convai")
        .forEach(el => el.remove());

      document
        .querySelectorAll(
          "iframe,[class*='convai'],[id*='convai']"
        )
        .forEach(el => el.remove());

    };

    hideWidget();

    const interval =
      setInterval(hideWidget, 500);

    return () =>
      clearInterval(interval);

  }, []);

  // Scroll top

  useEffect(() => {

    window.scrollTo({

      top: 0,

      behavior: "smooth"

    });

  }, []);

  // Countdown target

  const [targetDate,
    setTargetDate] =
    useState(getNextSaturday());

  // Countdown

  const [countdown,
    setCountdown] =
    useState({

      days: 0,

      hours: 0,

      minutes: 0,

      seconds: 0

    });

  // Blur Slider

  const [blur,
    setBlur] =
    useState(0);

  // Registered count

  const [weekCount,
    setWeekCount] =
    useState(0);

  // Registration popup

  const [showModal,
    setShowModal] =
    useState(false);

  // Form

  const [formData,
    setFormData] =
    useState({

      name: "",

      email: "",

      phoneNumber: ""

    });

  const [loading,
    setLoading] =
    useState(false);

  // Countdown

  useEffect(() => {

    const timer =
      setInterval(() => {

        const now = new Date();

        const diff =
          targetDate - now;

        if (diff <= 0) {

          setTargetDate(
            getNextSaturday()
          );

          return;

        }

        setCountdown({

          days:
            Math.floor(
              diff /
              (1000 * 60 * 60 * 24)
            ),

          hours:
            Math.floor(
              diff /
              (1000 * 60 * 60)
            ) % 24,

          minutes:
            Math.floor(
              diff /
              (1000 * 60)
            ) % 60,

          seconds:
            Math.floor(
              diff /
              1000
            ) % 60

        });

      }, 1000);

    return () =>
      clearInterval(timer);

  }, [targetDate]);

  // Weekly registrations

  useEffect(() => {

    const loadCount =
      async () => {

        try {

          const res =
            await axios.get(
              "/api/vision-ignite-week-count"
            );

          setWeekCount(
            res.data.count
          );

        }

        catch (err) {

          console.log(err);

        }

      };

    loadCount();

    const interval =
      setInterval(
        loadCount,
        5000
      );

    return () =>
      clearInterval(interval);

  }, []);

  // Lock page scroll while the popup is open

  useEffect(() => {

    document.body.style.overflow =
      showModal ? "hidden" : "";

    return () => {
      document.body.style.overflow = "";
    };

  }, [showModal]);

  // Close popup on Escape

  useEffect(() => {

    const onKeyDown = (e) => {
      if (e.key === "Escape") {
        setShowModal(false);
      }
    };

    document.addEventListener("keydown", onKeyDown);

    return () =>
      document.removeEventListener("keydown", onKeyDown);

  }, []);

  // Input

  const handleChange = e => {

    setFormData({

      ...formData,

      [e.target.name]:
      e.target.value

    });

  };

  // Register

  const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    setLoading(true);

    await axios.post(
      "/api/vision-ignite-webinar-register",
      formData
    );

    // ✅ GA4 Event - Successful Registration
    if (window.gtag) {
      window.gtag("event", "vision_ignite_registration_success", {
        name: formData.name,
        page: "/vision-ignite-webinar",
      });
    }

    alert("Registration Successful!");

    setFormData({
      name: "",
      email: "",
      phoneNumber: "",
    });

    setShowModal(false);
  } catch (err) {
    alert(
      err.response?.data?.message ||
      "Registration Failed"
    );
  } finally {
    setLoading(false);
  }
};

return (
  <div className="vision-webinar-page">

    <div className="page-layout">

      {/* ================= LEFT COLUMN ================= */}

      <div className="left-column">

        {/* HERO */}

        <section className="vi-hero">

          <div className="vi-left">

            <span className="vi-tag">
              🔴 Vision Ignite — Live Webinar
            </span>

            <h1>
              Clear vision is a skill too.
              <br />
              Come <span>train your eyes live.</span>
            </h1>

            <p>
              A live, hands-on session on the natural eye-training
              techniques behind reducing screen strain,
              sharpening focus, and building healthier vision habits —
              for anyone tired of reaching for their glasses.
            </p>

          </div>

        </section>

        {/* WHY SECTION */}

        <section className="why-section">

          <div className="section-title">

            <h2>
              Your eyes are trainable too — not just your eyesight.
            </h2>

            <p>
              Most people treat glasses as a one-way street:
              once you need them, that's it for life.

              Vision Ignite walks through the eye-training
              techniques behind reducing screen strain,
              easing dependence on corrective lenses,
              and building habits that support clearer sight.
            </p>

          </div>

          <div className="feature-grid">

            <div className="feature-card">
              <h3>The science</h3>
              <p>
                How daily strain builds up in your eyes
                and what actually gives them room to recover.
              </p>
            </div>

            <div className="feature-card">
              <h3>The live clarity check</h3>
              <p>
                Run a simple self-check together and
                get a feel for your own starting point.
              </p>
            </div>

            <div className="feature-card">
              <h3>The method</h3>
              <p>
                The exact protocol behind Forge Your Peak,
                broken into three repeatable techniques.
              </p>
            </div>

            <div className="feature-card">
              <h3>The plan</h3>
              <p>
                A five-minute daily routine you can start
                immediately after the webinar.
              </p>
            </div>

          </div>

        </section>

      </div>

      {/* ================= RIGHT COLUMN ================= */}

      <aside className="register-right">

        <div className="register-card">

          <h2>Reserve Your Seat</h2>

          <p className="seatText">
            🔥 <b>Limited to 100 Seats</b>
           
          </p>

          <div className="countdown">

            <div>
              <h2>{countdown.days}</h2>
              <span>Days</span>
            </div>


            <div>
              <h2>{countdown.hours}</h2>
              <span>Hours</span>
            </div>

            <div>
              <h2>{countdown.minutes}</h2>
              <span>Minutes</span>
            </div>

            <div>
              <h2>{countdown.seconds}</h2>
              <span>Seconds</span>
            </div>

          </div>

          <form onSubmit={handleSubmit}>

            <div className="input-group">
              <FaUser className="input-icon" />
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="input-group">
              <FaEnvelope className="input-icon" />
              <input
                type="email"
                name="email"
                placeholder="Email Address"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="input-group">
              <FaPhoneAlt className="input-icon" />
              <input
                type="text"
                name="phoneNumber"
                placeholder="Phone Number"
                value={formData.phoneNumber}
                onChange={handleChange}
                required
              />
            </div>

            <button
              type="submit"
              disabled={loading}
            >
              {loading ? "Registering..." : "Join Vision Ignite"}
            </button>

          </form>

          <p className="register-note">
            📧 Webinar link will be sent to your email immediately.
          </p>

        </div>

      </aside>

    </div>

  </div>
);
};

export default VisionIgniteWebinar;
